
export default function InputCheckBox({checked=false,name,onChange,label,disabled=false,value}) {


    return (
        <div className="flex items-center">
            <input className="mr-2 size-3" type="checkbox" value={value} id={name} name={name} onChange={onChange} checked={checked} disabled={disabled}/>
            <label className={"text-sm"+(disabled?" text-gray ":" text-dark-green cursor-pointer")} htmlFor={name}>{label}</label>
        </div>
    )
}